import { generatePath } from "react-router";

// App
import { appendUrlParams, fetchDelete, fetchGet, fetchPatch, fetchPost } from "../../../utilities";
import { URI_USER, URI_USER_ADD, URI_USER_DELETE, URI_USER_EDIT, URI_USER_FORM } from "../constants/uris";

// User
import {
  USER_FORM_CLEAR,
  USER_FORM_FETCH_REQUEST,
  USER_FORM_FETCH_RESPONSE_ERROR,
  USER_FORM_FETCH_RESPONSE_SUCCESS,
  USER_FORM_INIT_REQUEST,
  USER_FORM_INIT_RESPONSE_ERROR,
  USER_FORM_INIT_RESPONSE_SUCCESS,
  USER_FORM_SUBMIT_REQUEST,
  USER_FORM_SUBMIT_RESPONSE_ERROR,
  USER_FORM_SUBMIT_RESPONSE_SUCCESS,
  USER_GRID_CHANGE_FILTER,
  USER_GRID_CHANGE_PAGINATION,
  USER_GRID_CHANGE_SORT,
  USER_GRID_DELETE_REQUEST,
  USER_GRID_DELETE_RESPONSE_ERROR,
  USER_GRID_DELETE_RESPONSE_SUCCESS,
  USER_GRID_FETCH_REQUEST,
  USER_GRID_FETCH_RESPONSE_ERROR,
  USER_GRID_FETCH_RESPONSE_SUCCESS,
} from "../constants/actionTypes";

// FORM - Clear
export const formClear = () => {
  return (dispatch) => {
    dispatch({
      type: USER_FORM_CLEAR,
    });
  };
};

// FORM - Fetch
export const formFetch = (id) => {
  return async (dispatch, getState) => {
    const state = getState();

    if (false === state.user.formIsFetching) {
      dispatch({
        type: USER_FORM_FETCH_REQUEST,
      });

      await fetchGet(generatePath(URI_USER_EDIT, { id: id }))
        .then((res) => {
          if (res.ok) {
            dispatch({
              type: USER_FORM_FETCH_RESPONSE_SUCCESS,
              payload: res.body,
            });
          } else {
            dispatch({
              type: USER_FORM_FETCH_RESPONSE_ERROR,
              payload: res.body,
            });
          }
        })
        .catch((err) => {
          dispatch({
            type: USER_FORM_FETCH_RESPONSE_ERROR,
            payload: [err.message],
          });
        });
    }
  };
};

// FORM - Init
export const formInit = (data, id = null) => {
  return async (dispatch, getState) => {
    const state = getState();

    if (false === state.user.formIsInitializing) {
      dispatch({
        type: USER_FORM_INIT_REQUEST,
      });

      if (null === id) {
        id = 0;
      }

      await fetchPost(generatePath(URI_USER_FORM, { id: id }), data)
        .then((res) => {
          if (res.ok) {
            dispatch({
              type: USER_FORM_INIT_RESPONSE_SUCCESS,
              payload: res.body,
            });
          } else {
            dispatch({
              type: USER_FORM_INIT_RESPONSE_ERROR,
              payload: res.body,
            });
          }
        })
        .catch((err) => {
          dispatch({
            type: USER_FORM_INIT_RESPONSE_ERROR,
            payload: [err.message],
          });
        });
    }
  };
};

// FORM - Submit - Create
export const formSubmitCreate = (data) => {
  return async (dispatch) => {
    dispatch({
      type: USER_FORM_SUBMIT_REQUEST,
    });

    await fetchPost(URI_USER_ADD, data)
      .then((res) => {
        if (res.ok) {
          dispatch({
            type: USER_FORM_SUBMIT_RESPONSE_SUCCESS,
            payload: res.body,
          });
        } else {
          dispatch({
            type: USER_FORM_SUBMIT_RESPONSE_ERROR,
            payload: res.body,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: USER_FORM_SUBMIT_RESPONSE_ERROR,
          payload: [err.message],
        });
      });
  };
};

// FORM - Submit - Update
export const formSubmitUpdate = (data, id) => {
  return async (dispatch) => {
    dispatch({
      type: USER_FORM_SUBMIT_REQUEST,
    });

    await fetchPatch(generatePath(URI_USER_EDIT, { id: id }), data)
      .then((res) => {
        if (res.ok) {
          dispatch({
            type: USER_FORM_SUBMIT_RESPONSE_SUCCESS,
            payload: res.body,
          });
        } else {
          dispatch({
            type: USER_FORM_SUBMIT_RESPONSE_ERROR,
            payload: res.body,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: USER_FORM_SUBMIT_RESPONSE_ERROR,
          payload: [err.message],
        });
      });
  };
};

// GRID - Change - Filter
export const gridChangeFilter = (filters) => {
  return (dispatch) => {
    dispatch({
      type: USER_GRID_CHANGE_FILTER,
      payload: {
        filters: filters,
      },
    });
  };
};

// GRID - Change - Pagination
export const gridChangePagination = (page, pageSize) => {
  return (dispatch) => {
    dispatch({
      type: USER_GRID_CHANGE_PAGINATION,
      payload: {
        page: page,
        pageSize: pageSize,
      },
    });
  };
};

// GRID - Change - Sort
export const gridChangeSort = (sortField, sortOrder) => {
  return (dispatch) => {
    dispatch({
      type: USER_GRID_CHANGE_SORT,
      payload: {
        sortField: sortField,
        sortOrder: sortOrder,
      },
    });
  };
};

// GRID - Delete
export const gridDelete = (id) => {
  return async (dispatch) => {
    dispatch({
      type: USER_GRID_DELETE_REQUEST,
    });

    await fetchDelete(generatePath(URI_USER_DELETE, { id: id }))
      .then((res) => {
        if (res.ok) {
          dispatch({
            type: USER_GRID_DELETE_RESPONSE_SUCCESS,
            payload: res.body,
          });
        } else {
          dispatch({
            type: USER_GRID_DELETE_RESPONSE_ERROR,
            payload: res.body,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: USER_GRID_DELETE_RESPONSE_ERROR,
          payload: [err.message],
        });
      });
  };
};

// GRID - Fetch
export const gridFetch = () => {
  return (dispatch, getState) => {
    const state = getState();
    if (false === state.user.gridIsFetching) {
      dispatch({
        type: USER_GRID_FETCH_REQUEST,
      });

      const urlParams = appendUrlParams(
        state.user.gridFilters,
        state.user.gridPage,
        state.user.gridPageSize,
        state.user.gridSortField,
        state.user.gridSortOrder
      );

      fetchGet(URI_USER + urlParams)
        .then((res) => {
          if (res.ok) {
            dispatch({
              type: USER_GRID_FETCH_RESPONSE_SUCCESS,
              payload: res.body,
            });
          } else {
            dispatch({
              type: USER_GRID_FETCH_RESPONSE_ERROR,
              payload: res.body,
            });
          }
        })
        .catch((err) => {
          dispatch({
            type: USER_GRID_FETCH_RESPONSE_ERROR,
            payload: [err.message],
          });
        });
    }
  };
};
